// extracted by mini-css-extract-plugin
export default {"cta":"BlogCta_cta__R7eu2","heading":"BlogCta_heading__aBspH","text":"BlogCta_text__ieRy6","button":"BlogCta_button__8sgfi","buttonLabel":"BlogCta_buttonLabel__k75BS"};